import { Component, OnInit, Input } from '@angular/core';
import { Clipboard } from '@ionic-native/clipboard/ngx';
import { handleCopy } from '../../angular-wallet-base/utils';
import { AlertController, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ClipboardService } from 'ngx-clipboard';

@Component({
  selector: 'virtual-debit-card',
  templateUrl: './debit-card.component.html',
  styleUrls: ['./debit-card.component.scss'],
})
export class DebitCardComponent implements OnInit {
  @Input() ccNumber: string;
  @Input() cvv: string;
  @Input() expMonth: string;
  @Input () expYear: string;

  constructor(private clipboard: Clipboard,
              private alert: AlertController,
              private platform: Platform,
              private clipboardService: ClipboardService,
              private translate: TranslateService) { }

  ngOnInit() {}

  parseCCNumber() {
    return [
      this.ccNumber.slice(0, 4),
      this.ccNumber.slice(4, 8),
      this.ccNumber.slice(8, 12),
      this.ccNumber.slice(12, 16)
    ]
  }

  canCopyNumber() {
    return this.ccNumber.indexOf('*') === -1;
  }

  async copyNumber() {
    if (this.canCopyNumber()) {
      const ccNumber = this.ccNumber.toString();
      await handleCopy(ccNumber, this.platform, this.clipboard, this.alert, this.translate, this.clipboardService, null);
    }
  }
}
